import styled from 'styled-components'
import Link from 'next/link'

import device from 'utils/device'
import Svg from 'components/Svg'

export default function HelpItem({ nr, href, description, name, onClick }) {
    return (
        <Container onClick={onClick}>
            {href && (
                <Link href={href} aria-label={name}>
                    {name}
                </Link>
            )}
            <Svg name={`help-${nr}`} />
            <Name>{name}</Name>
            <Description>{description}</Description>
        </Container>
    )
}

const Container = styled.div`
    text-align: left;
    position: relative;
    cursor: pointer;
    background: var(--color-white);
    border-radius: 0.24rem;
    padding: 0.36rem;
    width: 3.84rem;
    text-align: center;
    transition: transform 300ms ease-in-out;
    a {
        font-size: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
    svg {
        width: 0.36rem;
        height: 0.36rem;
        margin-bottom: 0.36rem;
    }
    &:hover {
        transform: scale(1.05);
    }
    ${device.mobile} {
        padding: 0.24rem;
        width: auto;
        margin-bottom: 0.16rem;
        svg {
            width: 0.36rem;
            height: 0.36rem;
            margin-bottom: 0.24rem;
        }
        &:hover {
            transform: none;
        }
    }
`

const Name = styled.h3`
    font-weight: 600;
    font-size: 0.22rem;
    margin-bottom: 0.16rem;
    ${device.mobile} {
        font-size: 0.2rem;
    }
`

const Description = styled.p`
    margin: 0;
`
